import React, {useEffect, useState} from "react"
import {connect, useDispatch} from "react-redux"
import ShowAttachment from "../../function/hooks/showAttachment"
import Styles from "./attachment.less"
import closeImg from "../../static/pic/close.svg"
import Table from "../common/table"
import {ATTACHMENTTABLEDATA} from "../util/utilData"
import {ReducerState} from "../../reducer/interface/baseInterface"
import {AttachmentItem, TabAttachment} from "../../reducer/interface/dataInterface"
import {UseModel} from "../../function/hooks/useDataFromRedux"
import {getVaildFileType} from "../upload/uploadFile/uploadFile"

interface AttachmentProps {
    attachmentList: Array<TabAttachment>
}

const Attachment: React.FunctionComponent<AttachmentProps> = (props) => {
    const showAttachment = ShowAttachment()
    const model = UseModel()
    const [activePageLabel, setActivePageLabel] = useState<TabAttachment>({
        key: "defaultActivePageLabelKey",
        name: "",
        data: [],
    })

    const dispatch = useDispatch()
    useEffect(() => {
        if (props.attachmentList.length > 0) {
            setActivePageLabel(props.attachmentList[0])
        } else {
            setActivePageLabel({key: "defaultActivePageLabelKey", name: "", data: []})
        }
    }, [props.attachmentList])
    const [selectItem, setSelectItem] = useState<AttachmentItem | null>(null)
    const getLabelStyle = (labelData: TabAttachment) => {
        if (labelData.key === activePageLabel.key) {
            return {
                border: "1px solid #5582F3",
                color: "#FFFFFF",
                backgroundColor: "#5582F3",
            }
        } else {
            return {
                border: "1px solid #D9D9D9",
                color: "#666666",
                backgroundColor: "#FFFFFF",
            }
        }
    }
    const renderPageLabel = () => {
        return props.attachmentList.map((item) => (
            <div
                key={item.key}
                onClick={() => setActivePageLabel(item)}
                style={getLabelStyle(item)}
                className={Styles.labels}
            >
                {item.name}
            </div>
        ))
    }
    const onOk = () => {
        showAttachment.toFalse()
        if (selectItem) {
            // dispatch({
            //     type: `replaceNew${showAttachment.from}`,
            //     payload: {
            //         name: selectItem.fileName,
            //         type: selectItem.fileType,
            //         hasData: true,
            //         url: selectItem.url,
            //         status: "success",
            //     },
            // })
            dispatch({
                type: `replaceNew${showAttachment.from}`,
                payload: {
                    name: selectItem.fileName,
                    type: selectItem.fileType,
                    hasData: true,
                    url: selectItem.url,
                    status: "waiting",
                },
            })
            setTimeout(
                () =>
                    model.invokeAsync(`valid${showAttachment.from}File`, {
                        fileName: selectItem.fileName,
                        url: selectItem.url,
                        type: getVaildFileType(showAttachment.from),
                    }),
                500
            )
        }
    }
    return (
        <div style={{display: showAttachment.value ? "flex" : "none"}} className={Styles.mark}>
            <div className={Styles.AttachmentBox}>
                <div className={Styles.AttachmentHead}>
                    <span>附件列表</span>
                    <img onClick={() => showAttachment.toFalse()} className={Styles.closeImg} src={closeImg} alt={""} />
                </div>
                <div className={Styles.AttachmentBody}>
                    <div className={Styles.AttachmentPageLabel}>{renderPageLabel()}</div>
                    <Table
                        column={ATTACHMENTTABLEDATA.COLUMN}
                        dataSource={activePageLabel.data
                            .filter((item) => item.fileSize <= 10 * 1024 * 1024)
                            .map((data, index) => {
                                return {
                                    ...data,
                                    index: index + 1,
                                }
                            })}
                        onSelect={(item: AttachmentItem) => setSelectItem(item)}
                        selectItem={selectItem}
                    />
                </div>
                <div className={Styles.AttachmentFooter}>
                    {/* <span>不超过10M、500页，支持pdf、doc、docx 、jpg、jpeg、bmp、png、ofd格式。</span> */}
                    <button onClick={() => showAttachment.toFalse()} className={Styles.AttachmentCancelBtn}>
                        取消
                    </button>
                    <button onClick={onOk} className={Styles.AttachmentConfirmBtn}>
                        确认
                    </button>
                </div>
            </div>
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        attachmentList: state.data.attachmentList,
    }
})(Attachment)
